import { useEffect, useState } from "react";
import { producaov2 } from "../services/apis";


export async function requestConfigKey({key, fallbackValue, userToken, userID}){
  try {
    const response = await producaov2.get(`config-key/${key}`, {
      headers: {
        ...(typeof userToken === 'string' && {access_token: `voitto-token ${userToken}`})
      }
    });
  
    return response.data?.value || fallbackValue;
  } catch(error) {
    // logError({ err: error, extras: { description: "Falha ao buscar config key", userID, key, fallbackValue } });
    console.log("Error fetching config key:", error);

    return fallbackValue;
  }
}

export default function useConfigKey({ key = '', fallbackValue = null }) {
  const [value, setValue] = useState(fallbackValue);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const getConfigKey = async () => {
      setIsLoading(true);

      const token = localStorage.getItem('oauth_token');
      const user = localStorage.getItem('USER_NODE');

      const configValue = await requestConfigKey({ key, fallbackValue, userToken: token, userID: user?.id });

      if(isMounted) {
        setValue(configValue);
        setIsLoading(false);
      }
    }

    getConfigKey();

    return () => { isMounted = false }
  }, [key]);

  return {value};
}